import React from 'react';
import {
    SP_SKIP, extractResponseData, SmartStyles, SmartHeader, SmartSection, NoRecordsCard, RawResponseButton
} from './_SmartFieldRenderer';

const GROUPS = {
    enterprise:   { title: 'ENTERPRISE DETAILS',    icon: 'pi-briefcase',    keys: ['udyam_number', 'enterprise_name', 'type_of_enterprise', 'organization_type', 'major_activity', 'social_category'] },
    registration: { title: 'REGISTRATION',           icon: 'pi-calendar',     keys: ['date_of_incorporation', 'date_of_commencement'] },
    nic:          { title: 'NIC CODES',              icon: 'pi-hashtag',      keys: ['nic_2_digit_code', 'nic_4_digit_code', 'nic_5_digit_code'] },
    financials:   { title: 'FINANCIALS',             icon: 'pi-dollar',       keys: ['investment_in_plant_machinery', 'turnover'] },
    contact:      { title: 'CONTACT',                icon: 'pi-phone',        keys: ['mobile', 'email'] },
    address:      { title: 'ADDRESS',                icon: 'pi-map-marker',   keys: ['flat_no', 'building_name', 'road_name', 'city', 'district', 'state', 'pin_code'] },
};

const HIGHLIGHT = ['udyam_number'];

const UdyogAadharOutputComponent = ({ reportData, hideCredits, isSharedView }) => {
    const shouldHideCredits = hideCredits || isSharedView;
    const { responseData, remainingBalance, errorMsg, hasRealData } = extractResponseData(reportData);

    if (!reportData) return <NoRecordsCard subtitle="No data available" />;
    if (!responseData || !hasRealData) {
        return <NoRecordsCard errorMsg={errorMsg} subtitle="No records found for the provided details. Please verify and try again." />;
    }

    const d = responseData;
    const grouped = {};
    for (const [groupName, group] of Object.entries(GROUPS)) {
        const picked = {};
        group.keys.forEach(k => { if (k in d && d[k] !== null && d[k] !== undefined && d[k] !== '') picked[k] = d[k]; });
        if (Object.keys(picked).length > 0) grouped[groupName] = picked;
    }
    const knownKeys = new Set(Object.values(GROUPS).flatMap(g => g.keys));
    const leftover = {};
    for (const [k, v] of Object.entries(d)) {
        if (SP_SKIP.has(k) || knownKeys.has(k)) continue;
        if (v === null || v === undefined || v === '') continue;
        leftover[k] = v;
    }

    return (
        <div>
            <SmartStyles />
            <SmartHeader title="Udyog Aadhar / MSME Report" icon="pi-briefcase" remainingBalance={remainingBalance} shouldHideCredits={shouldHideCredits} />
            <div className="horizontal-report-card">
                {Object.entries(GROUPS).map(([groupName, meta]) => (
                    grouped[groupName]
                        ? <SmartSection key={groupName} title={meta.title} icon={meta.icon} data={grouped[groupName]} highlightKeys={HIGHLIGHT} />
                        : null
                ))}
                {Object.keys(leftover).length > 0 && (
                    <SmartSection title="OTHER DETAILS" icon="pi-info-circle" data={leftover} />
                )}
                <RawResponseButton data={d} />
            </div>
        </div>
    );
};

export default UdyogAadharOutputComponent;
